import React, { useRef, useEffect } from 'react';
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";

import * as s from './WatermarkThree.module.scss'

import Watermark from './../../../../images/svgs/logo-full.svg';

export const WatermarkThree = () => {
    const watermarkSVG = useRef(null)
    let watermarkClass;
    
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger)
        const svgWatermark = watermarkSVG.current?.querySelector(".circle");

        if(svgWatermark){
            const anim = gsap.timeline({
                scrollTrigger: {
                  trigger: svgWatermark,
                  start: "center 100%",
                  scrub: 1
                },
            });

            anim.fromTo(svgWatermark, 
                {
                    transformOrigin: 'center center',
                    rotate: "90deg"
                },
                {
                    rotate: 0
                }
            )
        }
    }, [])

    return (
        <div ref={watermarkSVG} className={`${s.watermarkContainer} ${watermarkClass}`}>
            <Watermark className={s.watermark} />
        </div>
    );
}